<template>
  <OModal>
    <OModalContainer class="p-4 sm:p-0 max-w-[410px]">
      <OModalOverlay @click="close"></OModalOverlay>
      <div
        class="
          dialog__content
          overflow-auto
          max-h-full
          bg-body-primary
          rounded-lg
          shadow-lg
          relative
          p-6
          d:p-8
          space-y-4
          min-w-[240px]
          max-w-[500px]
        "
      >
        <div v-if="title" class="modal__header text-lg font-bold text-center">{{ title }}</div>
        <div v-if="description" class="modal__desc space-y-2 text-center">
          {{ description }}
        </div>
        <div class="modal__actions u-center space-x-4">
          <OModalButton
            v-for="button in actions"
            :key="button.text"
            class="bg-[#306AFF]"
            :color-scheme="button.type"
            @click="getAction(button)()"
          >
            {{ button.text }}
          </OModalButton>
        </div>
      </div>
    </OModalContainer>
  </OModal>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OModal, OModalOverlay, OModalCloseButton, OModalContainer, OModalButton } from '~/modules/common/components/ui';
import { LANG } from '~/constants/config';
import i18n from '~/i18n';
export default defineComponent({
  components: { OModal, OModalOverlay, OModalCloseButton, OModalContainer, OModalButton },
  props: {
    /**
     * Modal Title
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Modal description
     * optinoal
     */
    description: {
      type: String,
      default: null,
    },
    /**
     * Buttons
     * @example
     * [
     *  { text: 'Vazgeç', action: 'close' },
     *  { text: 'Kaldır', type: 'primary', action: this.yourFunctionToBeCalled }
     * ]
     */
    actions: {
      type: Array,
      default: () => [{ text: i18n.messages[LANG].main.dialog.close }],
    },
    close: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const getAction = (button) => {
      // eslint-disable-next-line no-prototype-builtins
      return button.hasOwnProperty('action') ? () => button.action(props.close) : props.close;
    };
    const closeModal = () => {
      const data = {};
      props.close(data);
    };
    return { closeModal, getAction };
  },
});
</script>

<style></style>
